<div id="access-table">
  <app-ep-table [config]="config" [data]="access$ | async" data-cy="access-table"></app-ep-table>
</div>
